import { Snackbar, Alert, Stack } from '@mui/material'
import { useToastStore } from '../store/toastStore'

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const remove = useToastStore((s) => s.remove)

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 2000,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((t) => (
        <Snackbar
          key={t.id}
          open
          autoHideDuration={t.duration}
          onClose={() => remove(t.id)}
          sx={{ position: 'static', pointerEvents: 'auto' }}
        >
          <Alert
            severity={t.severity}
            variant="filled"
            onClose={() => remove(t.id)}
            sx={{ width: '100%', fontWeight: 500, minWidth: 280 }}
          >
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  )
}
